// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qowy","content":"styles_content__2UY4p"};